export default "__VITE_ASSET__cf741483__"